export const convertToTitleCase = (sentence) => {
  if (sentence?.length) return `${sentence.charAt(0).toUpperCase()}${sentence.slice(1)}`;
  else return '';
};
